import { subscriptionService } from "@/services/subscription";
import { Alert, Button, Loader, Stack, Text } from "@mantine/core";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import classes from "@/modules/subscription/subscription.module.css";
import { jalali } from "@/modules/subscription/SubscriptionNotices";
import { subscriptionKey } from "@/modules/subscription/useSubscription";

const PAID = ["Paid", "Success", "Succeeded", "Completed", "Active"];
const PENDING = ["Pending", "InProgress", "Waiting"];

// Back from the gateway: ask the server for the renewal's outcome, then refresh the header chip.
export default function SubscriptionResult() {
  const { id } = useParams();
  const client = useQueryClient();
  const inquiry = useQuery({ queryKey: ["subscription", "inquiry", id], queryFn: () => subscriptionService.inquiry(Number(id)), enabled: !!id, retry: 1, refetchInterval: (d) => (d && PENDING.includes(d.status) ? 4000 : false) });
  const paid = !!inquiry.data && PAID.includes(inquiry.data.status);
  useEffect(() => { if (paid) void client.invalidateQueries(subscriptionKey); }, [paid, client]);

  return (
    <div className={classes.page}>
      <section className={classes.panel}>
        {inquiry.isLoading || (inquiry.data && PENDING.includes(inquiry.data.status)) ? (
          <Stack align="center" py="lg"><Loader color="violet" /><Text>در حال بررسی نتیجهٔ پرداخت…</Text></Stack>
        ) : paid ? (
          <Alert color="green" title="اشتراک تمدید شد">اشتراک شما تا {jalali(inquiry.data?.endDate)} اعتبار دارد.</Alert>
        ) : (
          <Alert color="red" title="پرداخت انجام نشد">اگر مبلغی از حساب شما کم شده، طبق قوانین درگاه برمی‌گردد. می‌توانید دوباره تلاش کنید.</Alert>
        )}
        <div><Button component={Link} to="/dashboard/subscription" variant="default">بازگشت به اشتراک</Button></div>
      </section>
    </div>
  );
}
